import React, { useState, useCallback } from 'react';

import AccordionViewMore from '../../molecules/AccordionViewMore';
import Table, { TableProps } from '../Table';
import cls from '@soluto-design/styles/cls';
import { useIsBreakpointUp } from '@soluto-design/react';

export interface PricingDetailsSectionProps extends TableProps {
    toggleButtonOpen?: string;
    toggleButtonClose?: string;
    toggleButtonMobile?: string;
}

export default function PricingDetailsSection({
    toggleButtonOpen = 'Show',
    toggleButtonClose = 'Hide',
    toggleButtonMobile = 'View all features',
    ...tableProps
}: PricingDetailsSectionProps) {
    const [isOpen, setOpen] = useState(false);
    const isLgUp = useIsBreakpointUp('lg');

    const handleToggle = useCallback(
        () => setOpen((prevState) => !prevState),
        [],
    );

    const buttonLabel = isLgUp
        ? isOpen
            ? toggleButtonClose
            : toggleButtonOpen
        : toggleButtonMobile;

    return (
        <section>
            <div className="container">
                <AccordionViewMore
                    label={buttonLabel}
                    isOpen={isOpen}
                    onClick={handleToggle}
                />
            </div>
            <div
                className={cls(
                    'grid grid-rows-[0fr] opacity-0 transition-all ease-in-out duration-500 overflow-clip min-h-0 container',
                    isOpen && 'grid-rows-[1fr] opacity-100',
                )}>
                <div className="min-h-0">
                    <div className="relative">
                        <Table
                            {...tableProps}
                            titleTag="h4"
                            wrapperClassName="w-full"
                            allowMobile
                            headerClassName={cls(
                                'top-[94px] md:top-[100px] lg:top-[100px] w-full',
                            )}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}
